import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  MunilySelectFieldOption,
  MunilyTextFieldAppearance,
  MunilyTextFieldErrorMessages,
  MunilyTextFieldWidthLayout,
} from '../../../common-components/select-field/select-field.types';

@Component({
  selector: 'app-select-field-playground',
  templateUrl: './select-field-playground.component.html',
  styleUrls: ['./select-field-playground.component.scss'],
})
export class SelectFieldPlaygroundComponent {
  readonly appearances: MunilyTextFieldAppearance[] = ['outlined', 'filled'];
  readonly sizes = ['default', 'small'] as const;
  readonly widthLayouts: MunilyTextFieldWidthLayout[] = ['ds', 'fill'];

  appearance: MunilyTextFieldAppearance = 'outlined';
  size: 'default' | 'small' = 'default';
  widthLayout: MunilyTextFieldWidthLayout = 'ds';
  maxWidthCustom = '';
  label = 'Estado';
  hint = '';
  iconLeading = '';
  disabled = false;
  successful = false;

  demoOptions: MunilySelectFieldOption[] = [
    { value: 'a', label: 'Opción A' },
    { value: 'b', label: 'Opción B' },
    { value: 'c', label: 'Opción C' },
  ];

  demoControl = new FormControl('a');

  readonly countryOptions: MunilySelectFieldOption[] = [
    { value: 'co', label: 'Colombia' },
    { value: 'mx', label: 'México' },
    { value: 'es', label: 'España' },
  ];
  countryControl = new FormControl(null, Validators.required);

  countryErrorMessages: MunilyTextFieldErrorMessages = {
    required: 'Elige un país',
  };

  markCountryTouched(): void {
    this.countryControl.markAsTouched();
  }
}
